import React, { useEffect, useState } from "react";
import { Col, Divider, Input, Row, Space, Switch, Typography } from "antd";
import { COOKIE_EXPIRATION_TOOLTIP, renderInfoTip } from "../../../helper";
import { useSelector } from "react-redux";

const {Text} = Typography;

const SignalSharing = (props) => {
  const [shareRootDomain, setShareRootDomain] = useState(props.usPrivacyRegulation.shareRootDomain);
  const [writeFirstPartyCookiesFromServer, setWriteFirstPartyCookiesFromServer] = useState(props.usPrivacyRegulation.writeFirstPartyCookiesFromServer);
  const [usNatVersion, setUsNatVersion] = useState(props.usPrivacyRegulation.metaData.USNatVersion || 1);
  const [cookieMaxAge, setCookieMaxAge] = useState(props.usPrivacyRegulation.cookieMaxAge)
  const currentUser = useSelector((state) => state.accountState.getIn(["userDetails", "value"]));
  const handleRootDomainChange = (checked, e) => {
    setShareRootDomain(checked)
  }

  const handleFirstPartyCookiesChange = (checked, e) => {
    setWriteFirstPartyCookiesFromServer(checked)
  }

  const handleUsNatVersionChange = (checked, e) => {
    setUsNatVersion(checked ? 2 : 1)
  }

  const updateCookieMaxAge = ({target : {value}}) => {
    let intValue = parseInt(value);
    if (isNaN(intValue)) {
      intValue = '';
    } else if (intValue < 1) {
      intValue = 1;
    } else if (intValue > 36135) {
      intValue = 36135;
    }
    setCookieMaxAge(intValue)
  };

  useEffect(()=>{
    if(props.readOnly) return;
    props.usPrivacyRegulation.shareRootDomain = shareRootDomain;
    props.usPrivacyRegulation.writeFirstPartyCookiesFromServer = writeFirstPartyCookiesFromServer;
    props.usPrivacyRegulation.cookieMaxAge = cookieMaxAge;
    props.usPrivacyRegulation.metaData.USNatVersion = usNatVersion;
    props.resetValidationError();
  },[shareRootDomain,writeFirstPartyCookiesFromServer, cookieMaxAge, usNatVersion]);

  return (
    <Row gutter={[0,16]}>
      {!props.readOnly ? (
      <Col className="step-header" span={24}>
        <h4>Advanced Settings</h4>
      </Col>
      ) : null}
      <Col span={24} className={props.readOnly ? "" : "step-section padding-md"}>
        <Space direction="vertical" size={8}>
        <Typography.Text strong><Switch checked={shareRootDomain} disabled={props.readOnly} onChange={handleRootDomainChange} className="right-margin" size="small"/>Write 1st Party Cookies To Root Domain</Typography.Text>
          <Typography.Text>
          Toggling this setting ensures that the signal will be stored/persist across both the property's root domain and subdomains. In practice, this will ensure that users won't see the same message when moving from root to subdomain or vice versa.
          </Typography.Text>
        </Space>
        <Divider style={{margin: "16px 0"}}/>
        <Space direction="vertical" size={8}>
          <Typography.Text strong><Switch checked={writeFirstPartyCookiesFromServer} disabled={props.readOnly} onChange={handleFirstPartyCookiesChange} className="right-margin" size="small"/>Write 1st party cookies from the server to the property</Typography.Text>
          <Typography.Text>
          Toggling this setting on means that the server will set a 1st party cookie on your property, as opposed to the code on page setting the cookie which is the default state.
          </Typography.Text>
        </Space>
        { currentUser?.accountFeatures.includes('usnat_v2') && !props.usPrivacyRegulation?.nonIab ?
          (
            <>
            <Divider style={{margin: "16px 0"}}/>
            <Space direction="vertical" size={8}>
              <Typography.Text strong><Switch checked={usNatVersion === 2} disabled={props.readOnly || props.prevUSNatVersion === 2} onChange={handleUsNatVersionChange} className="right-margin" size="small"/>Upgrade to US National Section v2 (Breaking Changes)</Typography.Text>
              <Typography.Text>
              Upgrading to US National Section v2 introduces breaking changes: Sensitive Data Categories expand from 12 to 16 (including Inferred Health Information, Victim Information, National Origin and Transgender or Nonbinary categories). These fields are included even if not actively used, which impacts consent persistence and may affect revenue, if your vendors don't support this version. Please confirm your vendor support before switching and note that this change cannot be reverted.
              </Typography.Text>
              <Typography.Text>You can find IAB's documentation <Typography.Link href="https://github.com/InteractiveAdvertisingBureau/Global-Privacy-Platform/tree/main/Sections/US-National" target="_blank">here</Typography.Link>. If you have any questions or need further clarification, please contact us at <Typography.Link href="mailto:support@sourcepoint.com" >support@sourcepoint.com</Typography.Link></Typography.Text>
            </Space>
            </>
          ) : null
        }
        <Divider style={{margin: "16px 0"}}/>
          <Space direction="vertical" size={8}>
            <Space size={16}>
              <Text strong>Privacy Choice Expiration {renderInfoTip(COOKIE_EXPIRATION_TOOLTIP)} :</Text>
              <div>
                <Input
                  value={cookieMaxAge}
                  onChange={updateCookieMaxAge}
                  style={{width: 100}}
                  error={cookieMaxAge === ''}
                  disabled={props.readOnly}
                />
                <label>&nbsp;Days&nbsp;(up to 36135 Days)</label>
                <div>
                  {cookieMaxAge === '' ? <Text type="danger">Please enter a value greater than 0</Text> : null}
                </div>
              </div>
            </Space>
            <Text>Use the box to determine the length of time you want to the cookie which stores the state of user's privacy choices (opt ins / opt outs) to last before it expires</Text>
          </Space>
      </Col>
    </Row>
  )
}

export default SignalSharing;